import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { emptyModality, Modality } from "../../../../interfaces/modality";
import { deleteModality, getModalitySingle } from "../../../../services/modality";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminModalityDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminModalityDelete(props: AdminModalityDeleteProps) {
    const [modality, setModality] = useState<Modality>(emptyModality);

    const handleDelete = () => {
        deleteModality(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Modality cannot be deleted. There are teams of this modality."));
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getModalitySingle(props.id)
            .then(response => {
                setModality(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-modality-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("Delete modality") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { modality.id == 0 && 
                    <LoadingSpinner />
                }
                { modality.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_modality_message"
                                values={{
                                    modality_name: modality.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}